var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronLeftSm = function SvgChevronLeftSm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "chevron-left-sm_svg__svg-icon",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m28.16 23.5-8.5 8.5 8.5 8.5 8.5 8.5 2.13-2.13 2.13-2.13-6.37-6.37L28.18 32l6.37-6.37 6.37-6.37-2.13-2.13L36.66 15z",
    clipRule: "evenodd"
  })));
};
export { SvgChevronLeftSm as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTI4LjE1OTkgMjMuNDk5OUwxOS42NiAzMS45OTk5TDI4LjE1OTkgNDAuNDk5OEwzNi42NTk4IDQ4Ljk5OThMMzguNzg5OSA0Ni44Njk5TDQwLjkyIDQ0Ljc0MDFMMzQuNTUgMzguMzdMMjguMTggMzEuOTk5OUwzNC41NSAyNS42Mjk4TDQwLjkyIDE5LjI1OTdMMzguNzg5OSAxNy4xMjk4TDM2LjY1OTggMTVMMjguMTU5OSAyMy40OTk5WiIgZmlsbD0iY3VycmVudENvbG9yIi8+PC9zdmc+";